/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlSubmissionsQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  limit?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  exclude?: Types.InputMaybe<
    Array<Types.GqlExcludeCondition> | Types.GqlExcludeCondition
  >;
}>;

export type GqlSubmissionsQuery = {
  __typename: "Query";
  submissions: Array<{
    __typename: "Submission";
    uri: string;
    summary?: string | null;
    nextAutomaticReminderDate?: string | null;
    values: {
      __typename: "SubmissionValues";
      uri: string;
      matterId?: string | null;
      label?: string | null;
      operationId: string;
      status: Types.GqlSubmissionStatus;
      syncStatus?: Types.GqlSyncStatus | null;
      aiFillFiles?: Array<string> | null;
      aiFillFromMatterInfo?: boolean | null;
      deleted?: boolean | null;
      createdAt: string;
      updatedAt: string;
      completedAt?: string | null;
      sharedAt?: string | null;
      communicationMethod?: Types.GqlCommunicationMethod | null;
      recipientContactId?: string | null;
      hashUri?: string | null;
      verificationStatus?: Types.GqlSubmissionVerificationStatus | null;
      verificationDetails?: string | null;
      formVersionUri?: string | null;
      createdBy: {
        __typename: "User";
        uri: string;
        email: string;
        firstName: string;
        lastName: string;
        initials?: string | null;
        picture?: string | null;
        latestLoginAt?: string | null;
      };
      recipient?: {
        __typename: "Recipient";
        contactId: string;
        email: string;
        contactName: string;
        phone?: string | null;
        cell?: string | null;
        firstName?: string | null;
        lastName?: string | null;
      } | null;
      reminder?: {
        __typename: "SubmissionReminder";
        automaticCount?: number | null;
        manualCount?: number | null;
        manualStopTriggered?: boolean | null;
        lastAutomaticSentAt?: string | null;
        automaticStopReason?: string | null;
        matterNotFoundCount?: number | null;
      } | null;
    };
    form: {
      __typename: "Form";
      uri: string;
      fields: Array<{
        __typename: "Field";
        uri: string;
        values: {
          __typename: "FieldValues";
          uri: string;
          type: Types.GqlFieldType;
          label: string;
        };
      }>;
      values: {
        __typename: "FormValues";
        uri: string;
        operationId: string;
        deleted?: boolean | null;
        title: string;
        response: string;
        redirectUrl?: string | null;
        active?: boolean | null;
        teamUri: string;
        creationStatus?: string | null;
        source?: Types.GqlFormSource | null;
        matterId?: string | null;
        createdAt: string;
        updatedAt: string;
        category: Types.GqlFormCategory;
        publishedFormVersionUri?: string | null;
        hasUnpublishedChanges?: boolean | null;
        publishedAt?: string | null;
        aiFillSettings?: {
          __typename: "AIFillSettings";
          allowAiFill?: boolean | null;
          sectionTitle?: string | null;
          fileUploadLabel?: string | null;
          fileUploadDescription?: string | null;
        } | null;
        clientMessages?: {
          __typename: "ClientMessages";
          new?: string | null;
          reminder?: string | null;
        } | null;
        supportedLanguages?: Array<{
          __typename: "SupportedLanguage";
          key: string;
          label: string;
        }> | null;
        translations?: Array<{
          __typename: "FormTranslation";
          language: string;
          title?: string | null;
          response?: string | null;
          aiFillSectionTitle?: string | null;
          aiFillFileUploadLabel?: string | null;
          aiFillFileUploadDescription?: string | null;
        }> | null;
        createdBy: {
          __typename: "User";
          uri: string;
          email: string;
          firstName: string;
          lastName: string;
          initials?: string | null;
          picture?: string | null;
          latestLoginAt?: string | null;
        };
        updatedBy: {
          __typename: "User";
          uri: string;
          email: string;
          firstName: string;
          lastName: string;
          initials?: string | null;
          picture?: string | null;
          latestLoginAt?: string | null;
        };
        matterTypes: Array<{
          __typename: "MatterType";
          id: string;
          source: string;
          name: string;
          category: string;
          location: string;
          representativeOptions: Array<string>;
        }>;
        publishedBy?: {
          __typename: "User";
          uri: string;
          email: string;
          firstName: string;
          lastName: string;
          initials?: string | null;
          picture?: string | null;
          latestLoginAt?: string | null;
        } | null;
      };
      slug?: {
        __typename: "Slug";
        uri: string;
        values: {
          __typename: "SlugValues";
          uri: string;
          operationId: string;
          value: string;
          active: boolean;
          updatedAt: string;
          updatedBy: {
            __typename: "User";
            uri: string;
            email: string;
            firstName: string;
            lastName: string;
            initials?: string | null;
            picture?: string | null;
            latestLoginAt?: string | null;
          };
        };
      } | null;
      aiUserFeedback?: {
        __typename: "AIUserFeedback";
        uri: string;
        values: {
          __typename: "AIUserFeedbackValues";
          uri: string;
          formUri?: string | null;
          type: string;
          sourceFileIds?: Array<string> | null;
          status: Types.GqlAiUserFeedbackStatus;
          statusText?: string | null;
          output?: string | null;
          feedback?: string | null;
          rating?: number | null;
          updatedAt?: string | null;
        };
      } | null;
    };
    responses: Array<{
      __typename: "Response";
      uri: string;
      fieldUri: string;
      value: string;
      updatedAt: string;
      operationId: string;
      syncStatus?: Types.GqlSyncStatus | null;
      existingItemIds?: string | null;
      reviewBeforeUpdate?: string | null;
    }>;
    trackers?: Array<{
      __typename: "Tracker";
      uri: string;
      operationId: string;
      submissionUri: string;
      method?: string | null;
      sentAt?: string | null;
      userUri?: string | null;
      action?: string | null;
      user?: {
        __typename: "User";
        uri: string;
        email: string;
        firstName: string;
        lastName: string;
        initials?: string | null;
        picture?: string | null;
        latestLoginAt?: string | null;
      } | null;
    } | null> | null;
    aiUserFeedback?: {
      __typename: "AIUserFeedback";
      uri: string;
      values: {
        __typename: "AIUserFeedbackValues";
        uri: string;
        submissionUri?: string | null;
        type: string;
        sourceFileIds?: Array<string> | null;
        status: Types.GqlAiUserFeedbackStatus;
        statusText?: string | null;
        output?: string | null;
        feedback?: string | null;
        rating?: number | null;
        updatedAt?: string | null;
      };
    } | null;
    matter?: {
      __typename: "Matter";
      id: string;
      number?: string | null;
      title?: string | null;
      description?: string | null;
      isLead: boolean;
      status: string;
      matterTypeId: string;
      clientIds: Array<string>;
      otherSideIds: Array<string>;
      personResponsibleStaffId?: string | null;
    } | null;
  }>;
};

export const SubmissionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "submissions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "offset" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "limit" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "exclude" },
          },
          type: {
            kind: "ListType",
            type: {
              kind: "NonNullType",
              type: {
                kind: "NamedType",
                name: { kind: "Name", value: "ExcludeCondition" },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submissions" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "offset" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "offset" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "limit" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "limit" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "exclude" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "exclude" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "submissionFields" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "formFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Form" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uri" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "values" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uri" } },
                { kind: "Field", name: { kind: "Name", value: "operationId" } },
                { kind: "Field", name: { kind: "Name", value: "deleted" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "response" } },
                { kind: "Field", name: { kind: "Name", value: "redirectUrl" } },
                { kind: "Field", name: { kind: "Name", value: "active" } },
                { kind: "Field", name: { kind: "Name", value: "teamUri" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creationStatus" },
                },
                { kind: "Field", name: { kind: "Name", value: "source" } },
                { kind: "Field", name: { kind: "Name", value: "matterId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aiFillSettings" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "allowAiFill" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sectionTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fileUploadLabel" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "fileUploadDescription" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clientMessages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "new" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reminder" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "supportedLanguages" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "key" } },
                      { kind: "Field", name: { kind: "Name", value: "label" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "translations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "language" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "response" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "aiFillSectionTitle" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "aiFillFileUploadLabel" },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "aiFillFileUploadDescription",
                        },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uri" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "initials" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "picture" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "latestLoginAt" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "updatedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uri" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "initials" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "picture" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "latestLoginAt" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "category" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matterTypes" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "source" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "category" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "location" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "representativeOptions" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedFormVersionUri" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "hasUnpublishedChanges" },
                },
                { kind: "Field", name: { kind: "Name", value: "publishedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "publishedBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uri" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "initials" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "picture" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "latestLoginAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "slug" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uri" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uri" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "operationId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "active" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedBy" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uri" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "initials" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "picture" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "latestLoginAt" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "aiUserFeedback" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uri" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uri" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "formUri" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceFileIds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "output" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feedback" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rating" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "submissionFields" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Submission" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "uri" } },
          { kind: "Field", name: { kind: "Name", value: "summary" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "values" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uri" } },
                { kind: "Field", name: { kind: "Name", value: "matterId" } },
                { kind: "Field", name: { kind: "Name", value: "label" } },
                { kind: "Field", name: { kind: "Name", value: "operationId" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "syncStatus" } },
                { kind: "Field", name: { kind: "Name", value: "aiFillFiles" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "aiFillFromMatterInfo" },
                },
                { kind: "Field", name: { kind: "Name", value: "deleted" } },
                { kind: "Field", name: { kind: "Name", value: "createdAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "createdBy" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uri" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "initials" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "picture" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "latestLoginAt" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "completedAt" } },
                { kind: "Field", name: { kind: "Name", value: "sharedAt" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "communicationMethod" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipientContactId" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "recipient" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contactId" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contactName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                      { kind: "Field", name: { kind: "Name", value: "cell" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "hashUri" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "verificationStatus" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "verificationDetails" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "formVersionUri" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reminder" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "automaticCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "manualCount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "manualStopTriggered" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastAutomaticSentAt" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "automaticStopReason" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "matterNotFoundCount" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "nextAutomaticReminderDate" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "form" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "formFields" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fields" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uri" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "values" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "uri" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "type" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "label" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "responses" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uri" } },
                { kind: "Field", name: { kind: "Name", value: "fieldUri" } },
                { kind: "Field", name: { kind: "Name", value: "value" } },
                { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
                { kind: "Field", name: { kind: "Name", value: "operationId" } },
                { kind: "Field", name: { kind: "Name", value: "syncStatus" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "existingItemIds" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "reviewBeforeUpdate" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "trackers" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uri" } },
                { kind: "Field", name: { kind: "Name", value: "operationId" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "submissionUri" },
                },
                { kind: "Field", name: { kind: "Name", value: "method" } },
                { kind: "Field", name: { kind: "Name", value: "sentAt" } },
                { kind: "Field", name: { kind: "Name", value: "userUri" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uri" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "initials" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "picture" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "latestLoginAt" },
                      },
                    ],
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "action" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "aiUserFeedback" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "uri" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "values" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "uri" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "submissionUri" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "sourceFileIds" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "statusText" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "output" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "feedback" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "rating" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "updatedAt" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "matter" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "number" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
                { kind: "Field", name: { kind: "Name", value: "description" } },
                { kind: "Field", name: { kind: "Name", value: "isLead" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matterTypeId" },
                },
                { kind: "Field", name: { kind: "Name", value: "clientIds" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "otherSideIds" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "personResponsibleStaffId" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GqlSubmissionsQuery, GqlSubmissionsQueryVariables>;
